import { Link } from '@tanstack/react-router';
import { Button } from '@nw/ui';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-xl px-6 py-24">
      <h1 className="font-display text-4xl">Nothing lives at this address</h1>
      <p className="mt-3 text-[var(--nw-quiet)]">The page may have moved, or the item was deleted.</p>
      <Button asChild variant="primary" className="mt-6">
        <Link to="/">Go home</Link>
      </Button>
    </div>
  );
}
